import { render, staticRenderFns } from "./Twos.vue?vue&type=template&id=b5faf0d8&scoped=true&"
import script from "./Twos.vue?vue&type=script&lang=js&"
export * from "./Twos.vue?vue&type=script&lang=js&"
import style0 from "./Twos.vue?vue&type=style&index=0&id=b5faf0d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5faf0d8",
  null
  
)

component.options.__file = "Twos.vue"
export default component.exports